import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VesTransactionsService } from '../../../services/ves-transactions.service';
import { WorkingAccountService } from '../../../services/working-account.service';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import { CuentaTrabajo } from '../../../interfaces/cuenta-trabajo.interface';
import { SaveBalanceCajeroDTO } from '../../../interfaces/save-balance-cajero.dto';
import { BalanceCajeroTransacciones } from 'src/app/shared/enums/balance-transacciones.enum';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-approve-referencia-modal',
  templateUrl: './approve-referencia-modal.component.html',
})
export class ApproveReferenciaModalComponent {
  referencia: any;
  cuentaTrabajoMatch: CuentaTrabajo | null = null;
  loading = false;

  constructor(
    private vesTransactionsService: VesTransactionsService,
    private workingAccountService: WorkingAccountService,
    private cognitoService: CognitoService,
    public dialogRef: MatDialogRef<ApproveReferenciaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.referencia = data;
    this.cuentaTrabajoMatch = data.cuentaTrabajoMatch || null;
  }

  formatVES(amount: number | null | undefined): string {
    if (amount === null || amount === undefined) return '-';
    return new Intl.NumberFormat('es-VE', {
      style: 'currency',
      currency: 'VES',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  approve(): void {
    if (this.loading) return;

    if (!this.cuentaTrabajoMatch) {
      Swal.fire({
        icon: 'warning',
        title: 'Sin cuenta de trabajo',
        text: 'No se encontró una cuenta de trabajo VE asociada. No se puede procesar el abono automático.',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1e5a3f',
      });
      return;
    }

    this.loading = true;

    this.vesTransactionsService.approveReferenciaVes(this.referencia.id).subscribe({
      next: async () => {
        try {
          const user = await this.cognitoService.getAuthUser();
          const abono: SaveBalanceCajeroDTO = {
            monto: this.referencia.monto,
            tipoTransaccion: BalanceCajeroTransacciones.ABONO,
            tipo: 'TRABAJO',
            cuentaTrabajoID: this.cuentaTrabajoMatch!.cuenta_trabajo_id,
            precioCompra: 0,
            comentario: `Ref VES #${this.referencia.referencia} - Usuario ${this.referencia.userId}`,
            email: user.attributes.email,
            interno: false,
          };

          await this.workingAccountService.saveBalanceCajero(abono);

          Swal.fire({
            icon: 'success',
            title: 'Referencia aprobada',
            html: `
              <p>La referencia ha sido aprobada y el saldo acreditado al cliente.</p>
              <p style="margin-top: 8px; font-size: 0.85rem; color: #6b7280;">
                Abono registrado: <strong>${this.formatVES(this.referencia.monto)}</strong><br>
                Cuenta: <strong>${this.cuentaTrabajoMatch!.banco?.nombre} - ${this.cuentaTrabajoMatch!.numeroCuenta}</strong>
              </p>
            `,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#1e5a3f',
          });
          this.dialogRef.close(true);
        } catch (abonoError) {
          Swal.fire({
            icon: 'warning',
            title: 'Referencia aprobada, pero hubo un error',
            html: `
              <p>La referencia fue aprobada correctamente, pero <strong>no se pudo registrar el abono</strong> en la cuenta de trabajo.</p>
              <p style="margin-top: 8px; font-size: 0.85rem; color: #dc2626;">
                Registra el abono manualmente desde Abonos / D&eacute;bitos.
              </p>
            `,
            confirmButtonText: 'Entendido',
            confirmButtonColor: '#1e5a3f',
          });
          this.dialogRef.close(true);
        }
      },
      error: (err) => {
        this.loading = false;
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err.message || 'Error al aprobar la referencia',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#1e5a3f',
        });
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
